export const enum VenueType {
  CWH = 'CWH',
  House = 'HOUSE',
  Restaurant = 'Restaurant',
  GYM = 'GYM'
}
